import APIClient from '@/shared/http/clients/api'

const resourceName = 'regulationautospecify'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}`, data, config)
const GetAllPaging = (regulationAutoID, limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/GetAll/${regulationAutoID}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/${id}`, config)
const GetByRegulationAutoID = (regulationAutoID, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationautoid/${regulationAutoID}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegAuto}/${resourceName}/${id}`, config)

const RegulationAutoSpecifyRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  GetByRegulationAutoID,
  Create,
  Update,
  Delete
}

export default RegulationAutoSpecifyRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/regulation/auto/regulationautospecify.js